/** Props for {@link InProgress}. */
export interface InProgressProps {
  /** SVG width in pixels. Defaults to 22. */
  width?: number;
  /** SVG height in pixels. Defaults to 22. */
  height?: number;
  /** When false, renders only the spinner glyph without the circular badge. */
  withBadge?: boolean;
}

/**
 * Circular in-progress badge used in worklist tooltips and blocked-order states.
 *
 * @param props.width - SVG width in pixels
 * @param props.height - SVG height in pixels
 * @param props.withBadge - Whether to include the blue circular background
 * @returns SVG icon with a blue loading-style glyph
 */
const InProgress = ({
  width = 22,
  height = 22,
  withBadge = true,
}: InProgressProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {withBadge && (
        <>
          <rect
            x="0.5"
            y="0.5"
            width="21"
            height="21"
            rx="10.5"
            fill="#D6E7FF"
          />
          <rect
            x="0.5"
            y="0.5"
            width="21"
            height="21"
            rx="10.5"
            stroke="white"
          />
        </>
      )}
      <g clipPath="url(#clip0_22011_215298)">
        <path
          d="M11 6.125V7.375M11 14V16M7.875 11H6.125M15.625 11H14.875M14.2286 14.2286L13.875 13.875M14.3321 7.70789L13.625 8.415M7.46079 14.5392L8.875 13.125M7.56434 7.60434L8.625 8.665"
          stroke="#0056D6"
          strokeWidth="1.17"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_22011_215298">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(5 5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default InProgress;
